import PropTypes from 'prop-types';
import React from 'react';
import { Container, Grid, Header } from 'semantic-ui-react';
import ReactMarkdown from 'react-markdown';

import ArticleMenu from './../ArticleMenu';
import * as styles from './ArticlePageTemplate.less';

const ArticlePageTemplate = ({ contents = {}, page = {}, subMenu = false }) => (
  <div style={{ minHeight: '100vh', background: '#fff' }}>
    <div className={styles.subHeader}>
      <Container>
        <Grid>
          <Grid.Column width={16}>
            <Header sub as='h4'>
              {page.category}
            </Header>
            <Header sub as='h1'>
              {page.title}
            </Header>
          </Grid.Column>
        </Grid>
      </Container>
    </div>
    <Container>
      <Grid>
        {subMenu && (
          <Grid.Column computer={4} mobile={16}>
            <ArticleMenu items={contents} />
          </Grid.Column>
        )}
        <Grid.Column computer={subMenu ? 12 : 16} mobile={16}>
          {contents.map((content, key) => (
            <div key={key}>
              {content.title && (
                <Header className={styles.blogHeader} as='h2' id={content.link}>
                  {content.title}
                </Header>
              )}
              <ReactMarkdown
                className={styles.articleContent}
                source={content.text}
              />
            </div>
          ))}
        </Grid.Column>
      </Grid>
    </Container>
  </div>
);

ArticlePageTemplate.propTypes = {
  children: PropTypes.string,
  contents: PropTypes.array,
  page: PropTypes.object,
  subMenu: PropTypes.bool,
};

export default ArticlePageTemplate;



// WEBPACK FOOTER //
// ./src/views/components/ArticlePageTemplate/ArticlePageTemplate.js